import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import styled from '@emotion/styled';

import useUserContext from '../../hooks/use-user-context';
import { createOptionMap } from '../../utilities/misc';
import { rem } from '../../utilities/style';
import { colors } from '../../theme/colors';
import { media } from '../../theme/media';
import { containerStyles } from '../../styles/layout';
import { headers } from '../../styles/type';

import FeaturesTableHorizontal from './FeaturesTableHorizontal';
import FeaturesTableStacked from './FeaturesTableStacked';
import TextRenderer from '../TextRenderer';

const Container = styled.div`
  padding: ${rem(40)} 0;
`;

const ContentWrapper = styled.div`
  ${containerStyles.regular}
`;

const Headline = styled.h2`
  ${headers.h3}
  margin-bottom: ${rem(16)};
  color: ${colors.blue['800']};

  ${media('>small')} {
    margin-bottom: ${rem(40)};
  }
`;

const FeaturesTableHorizontalStyled = styled(FeaturesTableHorizontal)`
  display: none;

  ${media('>small')} {
    display: block;
  }
`;

const FeaturesTableStackedStyled = styled(FeaturesTableStacked)`
  ${media('>small')} {
    display: none;
  }
`;

const FeaturesTable = ({
  headline,
  variation,
  showMobileDropdown,
  mobileDropdownLabel,
  showExpandListButton,
  expandListText
}) => {
  const data = useStaticQuery(graphql`
    query FeaturesTable {
      allContentfulOptionSet(filter: {name: {eq: "features_table"}}) {
        nodes {
          ...OptionSetFragment
        }
      }
    }
  `);
  const { language } = useUserContext();
  const options = createOptionMap(data.allContentfulOptionSet.nodes, language);
  const tableData = options['features_table.data'];
  const tableHeading = options['features_table.table_heading_text'];

  // India Region
  // if (developerRegions.includes('india')) {
  //   tableData = {
  //     ...options['features_table.data'],
  //     ...options['features_table.data_in']
  //   };
  // }

  if (tableData === undefined || tableData[variation] === undefined) {
    return null;
  }

  return (
    <Container>
      <ContentWrapper>
        {headline && (
          <Headline>
            <TextRenderer text={headline} />
          </Headline>
        )}
        <FeaturesTableHorizontalStyled
          tableData={tableData[variation]}
          tableHeading={tableHeading}
          showExpandListButton={showExpandListButton}
          expandListText={expandListText}
        />
        <FeaturesTableStackedStyled
          tableData={tableData[variation]}
          showMobileDropdown={showMobileDropdown}
          mobileDropdownLabel={mobileDropdownLabel}
        />
      </ContentWrapper>
    </Container>
  );
};

FeaturesTable.propTypes = {
  headline: PropTypes.string,
  variation: PropTypes.string,
  showMobileDropdown: PropTypes.bool,
  mobileDropdownLabel: PropTypes.string,
  expandListText: PropTypes.string,
  showExpandListButton: PropTypes.bool
};

export default FeaturesTable;
